import React from "react";
import { map } from "lodash";
import styled from "styled-components";
import { Spacing } from "@glossy";
import Chip from "@ui-kit/form/chip";
import { Choice } from "@radarly/models/filters";

interface IProps {
  choices: Choice[];
  onSetChoices: (choice: Choice, status: string) => void;
  className?: string;
}

const Root = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${Spacing.ExtraSmall};
`;

const FilterbarPanelsChips = ({ choices, onSetChoices, className }: IProps) => {
  const handleClick = (choice: Choice) =>
    onSetChoices(choice, choice.status === "include" ? "none" : "include");

  return (
    <Root className={className}>
      {choices &&
        map(choices, (choice) => {
          const included = choice.status === "include";
          return (
            <Chip
              key={choice.id}
              label={choice.label}
              onClick={() => handleClick(choice)}
              status={included ? "include" : "none"}
            />
          );
        })}
    </Root>
  );
};

export default FilterbarPanelsChips;
